"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import {
    LayoutDashboard, FolderOpen, FileText, Mail, User,
    Settings, LogOut, Cpu, Tag, Briefcase, GraduationCap,
    Code, Languages, Heart, MousePointer2
} from "lucide-react";

const links = [
    { href: "/admin/dashboard", label: "Accueil", icon: <LayoutDashboard size={18} /> },
    { href: "/admin/services", label: "Services", icon: <Briefcase size={18} /> },
    { href: "/admin/projects", label: "Projets", icon: <FolderOpen size={18} /> },
    { href: "/admin/profile", label: "À Propos", icon: <User size={18} /> },
    { href: "/admin/articles", label: "Blog", icon: <FileText size={18} /> },
    { href: "/admin/messages", label: "Contact", icon: <Mail size={18} /> },

    { type: "header", label: "Gestion Avancée" },
    { href: "/admin/quotes", label: "Devis reçus", icon: <FileText size={18} /> },
    { href: "/admin/newsletter", label: "Newsletter", icon: <Mail size={18} /> },
    { href: "/admin/categories", label: "Catégories", icon: <Tag size={18} /> },
    { href: "/admin/experiences", label: "Expériences Pro", icon: <Briefcase size={18} /> },
    { href: "/admin/education", label: "Formations", icon: <GraduationCap size={18} /> },
    { href: "/admin/skills", label: "Compétences", icon: <Code size={18} /> },
    { href: "/admin/languages", label: "Langues", icon: <Languages size={18} /> },
    { href: "/admin/interests", label: "Centres d'intérêt", icon: <Heart size={18} /> },
    { href: "/admin/settings", label: "Paramètres Site", icon: <Settings size={18} /> },
];

export default function AdminSidebar() {
    const pathname = usePathname();

    const handleLogout = async () => {
        await fetch("/api/auth/logout", { method: "POST" });
        window.location.href = "/admin";
    };

    return (
        <aside style={{ width: 250, minHeight: "100vh", background: "#0f172a", display: "flex", flexDirection: "column", position: "sticky", top: 0, flexShrink: 0, overflowY: "auto" }}>
            {/* Logo */}
            <div style={{ padding: "1.75rem 1.5rem", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
                <Link href="/admin/dashboard" style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                    <div style={{ width: 36, height: 36, background: "var(--primary)", borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Cpu size={18} color="white" />
                    </div>
                    <div style={{ lineHeight: 1.2 }}>
                        <p style={{ color: "#f8fafc", fontFamily: "Outfit", fontWeight: 900, fontSize: "1rem" }}>Sergio</p>
                        <p style={{ color: "var(--primary)", fontSize: "0.7rem", fontWeight: 700, letterSpacing: "0.05em" }}>PORTFOLIO</p>
                    </div>
                </Link>
            </div>

            {/* Nav Links */}
            <nav style={{ flex: 1, padding: "1.25rem 0.75rem", display: "flex", flexDirection: "column", gap: "0.25rem" }}>
                {links.map((link, idx) => {
                    if (link.type === "header") {
                        return (
                            <p key={idx} style={{ padding: "1rem 1rem 0.5rem", fontSize: "0.65rem", fontWeight: 800, textTransform: "uppercase", color: "#475569", letterSpacing: "0.1em" }}>
                                {link.label}
                            </p>
                        );
                    }
                    const active = pathname === link.href;
                    return (
                        <Link key={link.href as string} href={link.href as string}
                            style={{
                                display: "flex", alignItems: "center", gap: "0.75rem", padding: "0.7rem 1rem",
                                borderRadius: "0.75rem", fontWeight: 700, fontSize: "0.85rem", transition: "all 0.15s",
                                background: active ? "rgba(37,99,235,0.2)" : "transparent",
                                color: active ? "#60a5fa" : "#94a3b8"
                            }}>
                            <span style={{ color: active ? "#60a5fa" : "#475569" }}>{link.icon}</span>
                            {link.label}
                        </Link>
                    );
                })}
            </nav>

            {/* Bottom */}
            <div style={{ padding: "1rem 0.75rem", borderTop: "1px solid rgba(255,255,255,0.08)" }}>
                <Link href="/" style={{ display: "flex", alignItems: "center", gap: "0.75rem", padding: "0.7rem 1rem", borderRadius: "0.75rem", color: "#64748b", fontWeight: 700, fontSize: "0.85rem" }}>
                    <MousePointer2 size={16} /> Voir le site
                </Link>
                <button onClick={handleLogout}
                    style={{ display: "flex", alignItems: "center", gap: "0.75rem", width: "100%", padding: "0.7rem 1rem", borderRadius: "0.75rem", color: "#f87171", fontWeight: 700, fontSize: "0.85rem", background: "none", border: "none", cursor: "pointer", textAlign: "left" }}>
                    <LogOut size={16} /> Déconnexion
                </button>
            </div>
        </aside>
    );
}
